export const drawerPaperStyles = {
  height: '100dvh',
  backgroundColor: ({ palette }) => palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: 'calc(env(safe-area-inset-top, 0px) + 12px) 16px 12px',
  borderBottom: '1px solid',
  borderColor: ({ palette }) => palette.divider,
};

export const closeButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  color: 'text.secondary',
  WebkitTapHighlightColor: 'transparent',
};

export const bodyStyles = {
  flex: 1,
  overflow: 'auto',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const emptyStateStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: '8px',
  padding: '32px 16px',
  color: 'text.secondary',
};

export const thumbnailGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
  gap: '12px',
};

export const labelFieldStyles = {
  marginTop: '8px',
};

export const footerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px 16px calc(env(safe-area-inset-bottom, 0px) + 16px)',
  borderTop: '1px solid',
  borderColor: ({ palette }) => palette.divider,
};

export const continueButtonStyles = {
  width: '100%',
  minHeight: '48px',
  borderRadius: '12px',
  textTransform: 'none',
};

export const addSourceStyles = {
  alignSelf: 'flex-start',
  textTransform: 'none',
};

export const emptyActionStyles = {
  alignSelf: 'center',
  marginTop: '8px',
  minHeight: '48px',
  borderRadius: '12px',
  textTransform: 'none',
};

export const hiddenInputStyles = {
  display: 'none',
};
